import { Button, ButtonType } from "components/Button/Button";
import { DataFetcher } from "components/DataFetcher";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./QuickSearch.scss";
import { getDataTestAttribute } from "utils/dataTestAttribute";
import SearchBox from "./SearchBox";

const QuickSearch = ({ bentobox = false, ...dataTest }) => {
	const navigate = useNavigate();
	const fetchData = { url: "/api/v3/Search/QuickSearch" };
	const [data, setData] = useState(null);
	const dataTestAttribute = getDataTestAttribute(dataTest);

	const handleSearch = (searchValue) => {
		navigate("/searchresults", { state: searchValue });
	};

	return (
		<div className={`quickSearch ${bentobox ? "bentobox" : ""}`} {...dataTestAttribute}>
			<SearchBox handleClick={handleSearch} data-test-id="quick-search-input" />
			<DataFetcher fetchData={fetchData} setData={setData}>
				<>
					{data?.length > 0 && <h2 data-test-id="quick-search-header">Quick Search</h2>}
					<div className="quickSearch-list">
						{data && data.map(link => (
							<div key={link.Name} className="listButton">
								<Button
									to="/searchresults?source=quicksearch"
									state={link.Name}
									text={link.Name}
									type={ButtonType.Secondary}
									data-test-class="quick-search-list-button"
								/>
							</div>
						))}
					</div>
				</>
			</DataFetcher>
		</div>
	);
};

export default QuickSearch;
